import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PixelButton from "@/components/PixelButton";
import AshLogo from "@/components/AshLogo";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, form);
      localStorage.setItem("mt_admin_token", data.token);
      nav("/admin/dashboard");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <form onSubmit={submit} className="pixel-panel w-full max-w-md space-y-4" data-testid="admin-login-form">
        <div className="text-center">
          <AshLogo variant="full" width={220} className="mx-auto" />
          <h2 className="pixel-font text-lg text-[#F58634] mt-3">ADMIN LOGIN</h2>
          <p className="vt323 text-lg text-[#1A1A1A]/70">Marketing Trail leads dashboard</p>
        </div>
        <div>
          <label className="pixel-font text-[10px] mb-1 block">USERNAME</label>
          <input
            data-testid="admin-username"
            className="pixel-input"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
          />
        </div>
        <div>
          <label className="pixel-font text-[10px] mb-1 block">PASSWORD</label>
          <input
            data-testid="admin-password"
            type="password"
            className="pixel-input"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
        </div>
        <PixelButton type="submit" data-testid="admin-login-submit" disabled={busy} className="w-full">
          {busy ? "Logging in…" : "Login ▶"}
        </PixelButton>
      </form>
    </div>
  );
}
